// @ts-strict-ignore
import { createReducer, on } from '@ngrx/store';
import * as DvrSettingsActions from '../actions/dvr-settings.actions';
import { DvrSettings } from '../model/dvr-settings';
import {
  FilterGroup,
  FilterItem,
} from '@fc-vehicles/components/shared/vehicle-filter/vehicles-filter.component';
import { Vehicle, VehicleGroup } from '@fc-core';
import { SelectionVehicle } from '../../settings/models/dvr-settings.model';

export const key = 'dvrSettings';

export interface State {
  dvrSettingsFilters: FilterGroup[];
  selectedFilters: FilterItem[];
  dvrSettings: DvrSettings[];
  updatingCameraIds: number[];
  dvrVehicleGroupsFilter: VehicleGroup[];
  searchText: string;
  loading: boolean;
  selectedVehicle: Vehicle;
  selectedVehicles: SelectionVehicle[];
}

export const initialState: State = {
  dvrVehicleGroupsFilter: [],
  searchText: '',
  dvrSettingsFilters: [
    {
      name: 'Orientation',
      filters: [
        { name: 'reversed', id: 'reversed' },
        { name: 'original', id: 'original' },
      ],
    },
    {
      name: 'Bump Sensitivity',
      filters: [
        { name: 'low', id: 'low' },
        { name: 'med', id: 'med' },
        { name: 'high', id: 'high' },
      ],
    },
    {
      name: 'Resolution',
      filters: [
        { name: '720', id: '720' },
        { name: '1080', id: '1080' },
        { name: '1440', id: '1440' },
      ],
    },
    {
      name: 'Inside camera',
      filters: [
        {
          name: 'On',
          id: 'inside_camera_on',
        },
        {
          name: 'Off',
          id: 'inside_camera_off',
        },
      ],
    },
  ],
  selectedFilters: [],
  dvrSettings: [],
  updatingCameraIds: [],
  loading: false,
  selectedVehicle: null,
  selectedVehicles: [],
};

export const reducer = createReducer(
  initialState,
  on(DvrSettingsActions.loadDvrSettings, (state) => ({
    ...state,
    loading: true,
  })),

  on(DvrSettingsActions.loadDvrSettingsSuccess, (state, action) => ({
    ...state,
    dvrSettings: action.dvrSettings,
    loading: false,
  })),
  on(DvrSettingsActions.loadCurrentDvrSettings, (state) => ({
    ...state,
    loading: true,
  })),
  on(DvrSettingsActions.loadCurrentDvrSettingsSuccess, (state, action) => {
    const dvrSettings = state.dvrSettings.find(
      (dvrSetting) => dvrSetting.camera.id === action.dvrSettings.camera.id,
    );
    if (dvrSettings) {
      return {
        ...state,
        dvrSettings: state.dvrSettings.map((dvrSetting) =>
          dvrSetting.camera.id === action.dvrSettings.camera.id
            ? action.dvrSettings
            : dvrSetting,
        ),
        loading: false,
      };
    }
    return {
      ...state,
      dvrSettings: [action.dvrSettings],
      loading: false,
    };
  }),
  on(DvrSettingsActions.updateManyDvrSetting, (state, action) => ({
    ...state,
    loading: true,
    updatingCameraIds: action.cameraIds,
  })),
  on(DvrSettingsActions.updateManyDvrSettingSuccess, (state, action) => ({
    ...state,
    loading: false,
    updatingCameraIds: [] as number[],
    dvrSettings: state.dvrSettings.map((setting) => {
      if (action.cameraIds.includes(setting.camera.id)) {
        return { ...setting, ...action.cameraSettingsList };
      }
      return setting;
    }),
  })),
  on(DvrSettingsActions.dvrSettingsFailure, (state) => ({
    ...state,
    loading: false,
    updatingCameraIds: [] as number[],
  })),
  on(DvrSettingsActions.setDvrVehicleGroupFilter, (state, action) => ({
    ...state,
    dvrVehicleGroupsFilter: action.vehicleGroups,
  })),
  on(DvrSettingsActions.setDvrSettingsSearchText, (state, action) => ({
    ...state,
    searchText: action.searchText,
  })),
  on(DvrSettingsActions.setDvrSettingsVehicle, (state, action) => ({
    ...state,
    selectedVehicle: action.vehicle,
  })),
  on(DvrSettingsActions.setDvrSelectedVehicles, (state, action) => ({
    ...state,
    selectedVehicles: action.vehicles,
  })),
  on(DvrSettingsActions.setDvrSettingsFilters, (state, action) => {
    let selectedFilters;
    if (action.filters) {
      selectedFilters = action.filters;
    } else {
      selectedFilters = state.selectedFilters.includes(action.filter)
        ? state.selectedFilters.filter((f) => f !== action.filter)
        : [...state.selectedFilters, action.filter];
    }
    return {
      ...state,
      selectedFilters,
    };
  }),
);

export const getDvrSettings = (state: State) => state.dvrSettings;
export const getLoading = (state: State) => state.loading;
export const getUpdatingCameraIds = (state: State) => state.updatingCameraIds;
export const getDvrSettingsFilters = (state: State) => state.dvrSettingsFilters;
export const getSelectedFilters = (state: State) => state.selectedFilters;
export const getDvrVehicleGroupsFilter = (state: State) =>
  state.dvrVehicleGroupsFilter;
export const getSearchText = (state: State) => state.searchText;
export const getSelectedVehicle = (state: State) => state.selectedVehicle;
export const getSelectedVehicles = (state: State) => state.selectedVehicles;
